import React from 'react'
import Navbar from './Navbar'
import postman from '../img/postman.png'
import mongo from '../img/mongo.jpg'
import vcode from '../img/vcode.png'

const Skills = () => {
    return (
        <section className="resume-section" id="skills">
            <Navbar />
            <div className="resume-section-content">
                <h2 className="mb-5">Skills</h2>
                <div className="subheading mb-3">Programming Languages And Tools</div>
                <ul className="list-inline dev-icons">
                    <li className="list-inline-item"><i className="fab fa-node"></i></li>
                    <li className="list-inline-item"><i className="fab fa-js-square"></i></li>
                    <li className="list-inline-item"><i className="fab fa-react"></i></li>
                    <li className="list-inline-item"><i className="fab fa-html5"></i></li>
                    <li className="list-inline-item"><i className="fab fa-css3-alt"></i></li>
                    <li className="list-inline-item"><i className="fas fa-database"></i></li>
                    <li className="list-inline-item"><i className="fab fa-npm"></i></li>
                    <li className="list-inline-item"><i className="fab fa-github"></i></li>
                    <li className="list-inline-item">
                        <img className="img-fluid img-profile rounded-circle mx-auto mb-2"
                            style={{ height: 50, widows: 50 }} src={postman} alt="" />
                    </li>
                    <li className="list-inline-item">
                        <img className="img-fluid img-profile  mx-auto mb-2" style={{ height: 50, widows: 50 }} src={mongo}
                            alt="" />
                    </li>
                    <li className="list-inline-item">
                        <img className="img-fluid img-profile  mx-auto mb-2" style={{ height: 50, widows: 50 }} src={vcode} alt="" />
                    </li>
                </ul>
                <div className="subheading mb-3">Workflow</div>
                <ul className="fa-ul mb-0">
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Backend using Node JS
                    </li>
                  <li>
                     <span className="fa-li"><i className="fas fa-check"></i></span>
                        Nest JS || Express JS
                    </li>
                  <li>
                     <span className="fa-li"><i className="fas fa-check"></i></span>
                       Graph QL
                    </li>
                  <li>
                     <span className="fa-li"><i className="fas fa-check"></i></span>
                       Redux
                    </li>
                  <li>
                     <span className="fa-li"><i className="fas fa-check"></i></span>
                      Typescript
                    </li>
                  <li>
                     <span className="fa-li"><i className="fas fa-check"></i></span>
                      MySql || Mongose || Postgres
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Mobile-First, Responsive Design
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Agile Development
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Firebase
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Heroku
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Digital Ocean
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        Single Page Application using React 
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default Skills
